import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export const DisconnectStanfordTaxConfirmation = (param)=>{
    let { testId, dismissModal } = param;
    const { t: stanfordTaxTexts } = useLocaleKeys('integrations.setup.stanfordTax');
    const { t: commonTexts } = useLocaleKeys('common');
    const decline = ()=>dismissModal(false);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'disconnect_stanford_tax_confirm'
            },
            secondaryButton: {
                name: 'disconnect_stanford_tax_cancel'
            },
            closeButton: {
                name: 'disconnect_stanford_tax_close'
            }
        },
        testId: testId,
        skin: "danger",
        title: stanfordTaxTexts.confirmDisconnectTitle(),
        content: /*#__PURE__*/ _jsx(Typography, {
            children: stanfordTaxTexts.confirmDisconnectContent()
        }),
        primaryButtonLabel: commonTexts.buttons.disconnect(),
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onPrimaryButtonClick: ()=>dismissModal(true),
        onSecondaryButtonClick: decline,
        onCloseButtonClick: decline
    });
};
